<template>
    <div id="search-desktop" class="desktop-only nav-search-element relative">

        <search-results-header :title="searchVisible && searchResultsOpen ? 'Recent' : 'Results'" v-if="searchResultsOpen" :results="results" />

        <input class="text-gray-800" :class="{resultsOpen: searchResultsOpen}" ref="query" v-if="searchVisible" v-model="query"
               id="search-box" type="text" placeholder="Search..." @keyup="doSearch()" @keyup.esc="closeSearch()"
               @keyup.enter="doSearch()"/>

    </div>
</template>

<script>
    var searchEmptyResults = {
        packages: [],
        archives: [],
        companies: [],
        people: [],
        pos: [],
        pis: [],
        sis: [],
        sos: []
    };

    export default {
        data() {
            return {
                query: '',
                searching: false,
                searchVisible: false,
                searchResultsOpen: false,
                results: searchEmptyResults
            }
        },
        watch: {
            searching: function () {
                if (this.searching) {
                    $('#close-search-link').hide();
                    $('#loading-search-link').show();
                } else {
                    $('#loading-search-link').hide();
                    $('#close-search-link').show();
                }
            }
        },
        computed: {},
        methods: {
            doSearch: _.debounce(function () {
                var that = this;
                if (this.query == '') {
                    return;
                }

                this.searching = true;
                axios.get(appUrls.search, {params: {query: this.query}}).then(function (response) {
                    if (that.searchVisible) {
                        that.searching = false;
                        that.results = response.data;
                        that.searchResultsOpen = true;
                    }
                });
            }, 200),
            resetSearchState: function () {
                this.searchResultsOpen = false;
                this.results = searchEmptyResults;
                this.query = '';
                this.searching = false;
            },
            closeSearch: function () {
                hideSearchBox();
            }
        },
        mounted() {
            var that = this;

            eventBus.$on('show-search', function () {
              that.searchVisible = true;
              that.resetSearchState();
              that.$forceUpdate();
              that.$nextTick(function () {
                that.$refs.query.focus();
              });
            });

            eventBus.$on('hide-search', function () {
                that.searchVisible = false;
                that.resetSearchState();
            });

            eventBus.$on('body-clicked', function (event) {
                setTimeout(function () {
                    if (that.searchVisible) {
                        let isWithinComponent = false;
                        let clickedElement = $(event.target);
                        let clickedElementParents = $(event.target).parents();

                        _.forEach(clickedElementParents, function (element) {
                            if ($(element).is($('#search-desktop')) || $(element).is($('#search-link'))) {
                                isWithinComponent = true;
                            }
                        });

                        if (!isWithinComponent && !clickedElement.is($('#search-link'))) {
                            hideSearchBox();
                            event.stopPropagation();
                        }
                    }
                }, 150);
            });

        }
    }
</script>

<style lang="scss">
    @import '../../sass/setup';

    .nav-search-element {
        #search-box {
            margin-right: 0.75em;
            margin-top: 14px;
            position: absolute;
            padding: 0.3em 0.8em;
            z-index:2000;
            font-size: 14px;
            left: -214px;
            width: 250px;
            top: -8px;
            border: 1px solid #1384bf;
            border-radius: $standardBorderRadius $standardBorderRadius 0 0;
            border-bottom: 1px none #1384bf;
            &:focus {
                box-shadow: none;
            }
        }

        .search-results, .search-history {
            position: absolute;
            left: -214px;
            width: 250px;
            top: 32px;
            background-color: #FFF;
            border-radius: 0 0 $standardBorderRadius $standardBorderRadius;
            padding: 1em;
            border: 1px solid #1384bf;
            border-top-style: none;
            max-height: 330px;
            z-index: 2000;
            overflow-y: scroll;
            -webkit-overflow-scrolling: touch;
            box-shadow: 3px 4px 4px 0px rgba(0, 0, 0, 0.04);
        }

        .search-history {
            ul li a {
                color: $brand !important;
                font-size: 12px;
            }
        }
    }

</style>
